import { useDark, useToggle } from "@vueuse/core";

/**
 * 主题管理 composable
 */
export const useTheme = () => {
  // 如果 localStorage 中没有主题设置，默认设置为暗色
  if (typeof window !== "undefined") {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === null) {
      localStorage.setItem("theme", "true");
    }
  }

  // 使用 VueUse 的 useDark 和 useToggle
  const isDark = useDark({
    selector: "html",
    attribute: "class",
    valueDark: "dark",
    valueLight: "",
    storageKey: "theme",
  });

  // 创建切换函数
  const toggleTheme = () => {
    isDark.value = !isDark.value;

    // 确保 Element Plus 也同步切换
    if (typeof window !== "undefined") {
      const html = document.documentElement;
      if (isDark.value) {
        html.setAttribute("data-el-theme", "dark");
      } else {
        html.removeAttribute("data-el-theme");
      }
    }
  };

  return {
    isDark,
    toggleTheme,
    setDark: () => {
      isDark.value = true;
      if (typeof window !== "undefined") {
        document.documentElement.setAttribute("data-el-theme", "dark");
      }
    },
    setLight: () => {
      isDark.value = false;
      if (typeof window !== "undefined") {
        document.documentElement.removeAttribute("data-el-theme");
      }
    },
  };
};
